import * as types from '../../actions/actionTypes';

const defaultState = {
  dataCheckKYC: null,
  data: null,
  dataUpload: null,
  submit: false,
  submitUpload: null,
  message: null,
  checkformSaveLocalStorage: null,
  messageUploadFail: null,
  messageCheckKYC: null,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case types.CHECK_KYC_COLLECTION_DONE:
      var checkformSaveLocalStorage = true;
      if (action.data) {
        checkformSaveLocalStorage = false;
      }
      return { ...state, dataCheckKYC: action.data, checkformSaveLocalStorage: checkformSaveLocalStorage };
    case types.CHECK_KYC_COLLECTION_FAIL:
      return { ...state, messageCheckKYC: action.reason };
    case types.SUBMIT_REGISTER:
      return { ...state, message: null };
    case types.SUBMIT_REGISTER_DONE:
      // registerKYC = {'cust_rfr_id':action.data.custRfrId,'account':action.data.account, 'identification_type':action.data.identification_type, 'identification_number':action.data.identification_number};
      // localStorage.setItem('registerKYCId', JSON.stringify(registerKYC));
      return { ...state, data: action.data, submit: true, message: null };
    case types.SUBMIT_REGISTER_FAIL:
      return { ...state, message: action.reason };
    case types.SUBMIT_REGISTER_UPLOAD_FILE:
      return { ...state, submitUpload: null, messageUploadFail: null, dataUpload: null };
    case types.SUBMIT_REGISTER_UPLOAD_FILE_DONE:
      localStorage.removeItem('registerKYCForm');
      return { ...state, dataUpload: action.data, submitUpload: true };
    case types.SUBMIT_REGISTER_UPLOAD_FILE_FAIL:
      return { ...state, submitUpload: false, messageUploadFail: action.data.message };
    default:
      return nextState;
  }
};
